import { ReactNode } from "react";
import Intercom from '@intercom/messenger-js-sdk';
import { getUnixTime } from "date-fns";

import { useAuthContext } from "@/hooks/useAuth";

export type IntercomProviderProps = {
  children: ReactNode;
};

export function IntercomProvider({ children }: IntercomProviderProps) {
  const { user } = useAuthContext();

  if (import.meta.env.VITE_INTERCOM_APP_ID) {
    Intercom({
      app_id: import.meta.env.VITE_INTERCOM_APP_ID,
      user_id: user.id,
      user_hash: user.intercomId,
      name: user.name,
      email: user.email,
      created_at: getUnixTime(user.created),
    });
  }

  return children;
}
